import { AppBar, Box, Container, Toolbar, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

const LayoutMain: React.FC = ({ children }) => {
  const { t } = useTranslation()

  return (
    <div>
      <header>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="static">
            <Toolbar>
              <Typography
                component="a"
                href="/"
                variant="h6"
                sx={{ flexGrow: 1, letterSpacing: '1px', color: 'inherit', textDecoration: 'none' }}
                noWrap
              >
                {t('title')}
              </Typography>
            </Toolbar>
          </AppBar>
        </Box>
      </header>
      <main>
        <Container maxWidth="lg">{children}</Container>
      </main>
    </div>
  )
}

export default LayoutMain
